export enum AutoAssignBarcodeType {
  DontAssign = 0,
  AutoAssignFree = 1,
  AutoAssignPaid = 2
}
